import { globalStyleObj } from "@/app/assets/styles";
import React from "react";
import { Skeleton } from "../../../ui/skeleton";
import {
  LabelText,
  NormalBrowseFileInputFiled,
  NormalTextEditorInputFiled,
  NormalTextInputField,
} from "../../..";

const NormalImageAndTextAndTextAreaCombinationInputFields = ({
  stateDetails,
  isFetching = false,
  allFilesResponse,
  labelText = "",
  fieldId = "",
  searchValue,
  selectedFileType,
  adminRole,
  permissionsList,
  handleImageChange,
  handleTextInputChange,
  handleTextEditorInputChange,
  isHideInOtherLanguages = false,
  translateField = false,
  extraContainerClasses = "",
  cards = [],
}) => {
  // Handle Image Change
  const passSelectedImageId = (fieldName, id) => {
    if (id) {
      handleImageChange(fieldName, id);
    } else {
      handleImageChange(fieldName, "");
    }
  };

  // Generate Image Input Field
  const getImageInputField = (i) => {
    const cardImageId = cards?.[i]?.image_field_id || null;

    if (!cardImageId) {
      return null;
    }

    return (
      isHideInOtherLanguages && (
        <NormalBrowseFileInputFiled
          isFetching={isFetching}
          fieldId={cardImageId}
          allFilesResponse={allFilesResponse}
          searchValue={searchValue}
          selectedFileType={selectedFileType}
          onChangeImageFunction={(id) => passSelectedImageId(cardImageId, id)}
          selectedFileId={stateDetails?.[cardImageId] || ""}
          adminRole={adminRole}
          permissionsList={permissionsList}
          extraContainerClasses="mb-5"
        />
      )
    );
  };

  // Generate Text Input || Text Area Field
  const getTextInputField = (i, placeHolder = null, isTextArea = false) => {
    const cardInputTextId = isTextArea
      ? cards?.[i]?.text_area_field_id || null
      : cards?.[i]?.text_field_id || null;

    return (
      <NormalTextInputField
        isFetching={isFetching}
        isTextArea={isTextArea}
        fieldId={cardInputTextId}
        fieldName={cardInputTextId}
        placeholderText={placeHolder || "Text"}
        inputValue={stateDetails?.[cardInputTextId] || ""}
        onChangeTextInputField={handleTextInputChange}
        extraContainerClasses="mb-5"
        translateField={true}
      />
    );
  };

  // Generate Text Editor Field
  const getTextEditorInputField = (i) => {
    const cardTextEditorId = cards?.[i]?.text_editor_field_id || null;
    const cardTextEditorPlaceholder =
      cards?.[i]?.text_editor_placeholder || null;

    if (!cardTextEditorId) {
      return null;
    }

    return (
      <NormalTextEditorInputFiled
        isFetching={isFetching}
        fieldId={cardTextEditorId}
        fieldName={cardTextEditorId}
        placeholderText={cardTextEditorPlaceholder || "TEXT"}
        inputValue={stateDetails?.[cardTextEditorId] || ""}
        onChangeTextEditorFiled={handleTextEditorInputChange}
        translateField={true}
      />
    );
  };

  return (
    <div
      className={`${globalStyleObj.commonSettingInputContainerClass} ${extraContainerClasses}`}
    >
      {isFetching ? (
        <Skeleton className="w-[150px] h-[30px] rounded-md" />
      ) : (
        <LabelText
          text={labelText}
          htmlForId={fieldId}
          translateField={translateField}
        />
      )}

      <ul className={`flex flex-col gap-2 w-full lg:max-w-[500px]`}>
        {cards.map((card, cardIndex) => (
          <li
            key={card.card_id}
            className="border border-dashed border-light-weight-400 p-2"
          >
            {card.types.map((type, index) => (
              <React.Fragment key={`fileds-${index + 1}`}>
                {type === "IMAGE" && getImageInputField(cardIndex)}

                {type === "TEXT" &&
                  getTextInputField(
                    cardIndex,
                    cards?.[cardIndex]?.text_input_placeholder || null,
                    false
                  )}

                {type === "TEXT_AREA" &&
                  getTextInputField(
                    cardIndex,
                    cards?.[cardIndex]?.textarea_input_placeholder || null,
                    true
                  )}

                {type === "TEXT_EDITOR" && getTextEditorInputField(cardIndex)}
              </React.Fragment>
            ))}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default NormalImageAndTextAndTextAreaCombinationInputFields;
